import { Form, Select } from "antd";
import React, { CSSProperties } from "react";

import "./FormItemSelect.scss";

const { Option } = Select;

interface FormItemInputProps {
  name: string;
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  defaultValue?: string | number;
  disabled?: boolean;
  items: { id: string | number; label: string; disabled?: boolean }[];
  showSearch?: boolean;
  style?: CSSProperties;
  onChange?: (value: string | number) => void;
}

const FormItemSelect: React.FC<FormItemInputProps> = ({
  name,
  placeholder,
  rules,
  label,
  defaultValue,
  disabled,
  items,
  showSearch,
  style,
  onChange,
}) => {
  return (
    <Form.Item
      style={style}
      className={`form-item__select ${disabled ? "disabled" : ""}`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <Select
        className={`select`}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        variant={"borderless"}
        showSearch={showSearch}
        optionFilterProp={"children"}
        onChange={onChange}
      >
        {items.map((el) => (
          <Option disabled={el.disabled} value={el.id} key={el.label}>
            {el.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default FormItemSelect;
